import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Dropzone } from "../../dropzone/dropzone.es.js";
function UploaderTabRenderer({
  tab,
  activeTabIndex,
  setActiveTabIndex,
  tabs,
  onRemoveTab,
  onDrop
}) {
  const currentIndex = activeTabIndex + 1;
  return /* @__PURE__ */ jsx("div", { id: `tab-${tab.id}`, style: {
    display: tab.id === tabs[activeTabIndex].id ? "inherit" : "none"
  }, children: /* @__PURE__ */ jsx(Dropzone, { onClear: () => {
    onRemoveTab(tabs[activeTabIndex].id);
    setActiveTabIndex(Math.max(0, currentIndex - 2));
  }, onDrop, ...tab.dropzone.props }, tab.dropzone.key) });
}
export {
  UploaderTabRenderer
};
//# sourceMappingURL=tab-renderer.es.js.map
